/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccountLinking,
  AccountLinkingCode,
  CompletionRateAudit,
  LocationDropDownContext,
  NotFoundError,
  PatchedUserRequest,
  ProCertification,
  PublicGigsterRequest,
  ServiceUnavailableError,
  UserLicense,
  UserNote,
  UserNoteRequest,
  UserRequest,
  UserResponse,
  UserRetrieveResponse,
  UsersAccountLinkingCodeCreate403,
  UsersActiveLocationsListParams,
  UsersApprovedLocationsListParams,
  UsersDeleteAccountCreate403,
  UsersLogoutAllDevicesCreate200,
  UsersPartialUpdate403,
  UsersUpdate403
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getUsersRetrieveUrl = (id: number | 'me',) => {




  return `/api/users/${id}/`
}

/**
 * A User represents a person capable of logging into Sidegig.
 *
 * A unique characteristic of this API is that 'me' is a special id value that always refers to the User for the
 * currently authenticated user.
 *
 * For example:
 * <ul>
 * <li><b>GET /users/me</b> returns the currently authenticated users User object</li>
 * <li><b>PUT /users/me</b> updates the currently authenticated users User object</li>
 * </ul>
 *
 * The first time a new user submits any API request a User is automatically created for them by the API. For
 * example, if a new user were to call GET /users/me for their very first API call it would return a new User where
 * the username maps to the authenticated users 'sub' value in their JWT (which ultimately maps to the Auth0 user's
 * username).
 */
export const usersRetrieve = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<UserRetrieveResponse> => {

  return customFetch<UserRetrieveResponse>(getUsersRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersRetrieveQueryKey = (id: number | 'me',) => {
    return [
    `/api/users/${id}/`
    ] as const;
    }


export const getUsersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersRetrieve>>> = ({ signal }) => usersRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersRetrieve>>>
export type UsersRetrieveQueryError = void


export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersRetrieve<TData = Awaited<ReturnType<typeof usersRetrieve>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersUpdateUrl = (id: number | 'me',) => {




  return `/api/users/${id}/`
}

/**
 * A User represents a person capable of logging into Sidegig.
 *
 * A unique characteristic of this API is that 'me' is a special id value that always refers to the User for the
 * currently authenticated user.
 *
 * For example:
 * <ul>
 * <li><b>GET /users/me</b> returns the currently authenticated users User object</li>
 * <li><b>PUT /users/me</b> updates the currently authenticated users User object</li>
 * </ul>
 *
 * The first time a new user submits any API request a User is automatically created for them by the API. For
 * example, if a new user were to call GET /users/me for their very first API call it would return a new User where
 * the username maps to the authenticated users 'sub' value in their JWT (which ultimately maps to the Auth0 user's
 * username).
 */
export const usersUpdate = async (id: number | 'me',
    userRequest: UserRequest, options?: Parameters<typeof customFetch>[1]): Promise<UserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UserResponse>(getUsersUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userRequest)
  }
);}





export const getUsersUpdateMutationKey = () => ['usersUpdate'] as const;

export const getUsersUpdateMutationOptions = <TError = void | UsersUpdate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdate>>, TError,UsersUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof usersUpdate>>, TError,UsersUpdateMutationVariables, TContext> => {

const mutationKey = getUsersUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersUpdate>>, UsersUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  usersUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersUpdate>>>
    export type UsersUpdateMutationBody = UserRequest
    export type UsersUpdateMutationError = void | UsersUpdate403
    export type UsersUpdateMutationVariables = {id: number | 'me';data: UserRequest}

    export const useUsersUpdate = <TError = void | UsersUpdate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersUpdate>>, TError,UsersUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersUpdate>>,
        TError,
        UsersUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getUsersUpdateMutationOptions(options), queryClient);
    }
    export const getUsersPartialUpdateUrl = (id: number | 'me',) => {




  return `/api/users/${id}/`
}

/**
 * A User represents a person capable of logging into Sidegig.
 *
 * A unique characteristic of this API is that 'me' is a special id value that always refers to the User for the
 * currently authenticated user.
 *
 * For example:
 * <ul>
 * <li><b>GET /users/me</b> returns the currently authenticated users User object</li>
 * <li><b>PUT /users/me</b> updates the currently authenticated users User object</li>
 * </ul>
 *
 * The first time a new user submits any API request a User is automatically created for them by the API. For
 * example, if a new user were to call GET /users/me for their very first API call it would return a new User where
 * the username maps to the authenticated users 'sub' value in their JWT (which ultimately maps to the Auth0 user's
 * username).
 */
export const usersPartialUpdate = async (id: number | 'me',
    patchedUserRequest?: PatchedUserRequest, options?: Parameters<typeof customFetch>[1]): Promise<UserResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UserResponse>(getUsersPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(patchedUserRequest)
  }
);}





export const getUsersPartialUpdateMutationKey = () => ['usersPartialUpdate'] as const;

export const getUsersPartialUpdateMutationOptions = <TError = void | UsersPartialUpdate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersPartialUpdate>>, TError,UsersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof usersPartialUpdate>>, TError,UsersPartialUpdateMutationVariables, TContext> => {

const mutationKey = getUsersPartialUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersPartialUpdate>>, UsersPartialUpdateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  usersPartialUpdate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof usersPartialUpdate>>>
    export type UsersPartialUpdateMutationBody = PatchedUserRequest | undefined
    export type UsersPartialUpdateMutationError = void | UsersPartialUpdate403
    export type UsersPartialUpdateMutationVariables = {id: number | 'me';data?: PatchedUserRequest}

    export const useUsersPartialUpdate = <TError = void | UsersPartialUpdate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersPartialUpdate>>, TError,UsersPartialUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersPartialUpdate>>,
        TError,
        UsersPartialUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getUsersPartialUpdateMutationOptions(options), queryClient);
    }
    export const getUsersAccountLinkingCodeCreateUrl = (id: number | 'me',) => {




  return `/api/users/${id}/account-linking-code/`
}

/**
 * Mint a single-use code authorizing another login to be linked into this account.
 *
 * A POST rather than a field on `linkable-accounts` because minting persists a row: that GET is
 * cached client-side and must stay free of side effects, and a mint behind a GET is an
 * unbounded row-growth vector.
 */
export const usersAccountLinkingCodeCreate = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<AccountLinkingCode> => {

  return customFetch<AccountLinkingCode>(getUsersAccountLinkingCodeCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUsersAccountLinkingCodeCreateMutationKey = () => ['usersAccountLinkingCodeCreate'] as const;

export const getUsersAccountLinkingCodeCreateMutationOptions = <TError = void | UsersAccountLinkingCodeCreate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersAccountLinkingCodeCreate>>, TError,UsersAccountLinkingCodeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof usersAccountLinkingCodeCreate>>, TError,UsersAccountLinkingCodeCreateMutationVariables, TContext> => {

const mutationKey = getUsersAccountLinkingCodeCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersAccountLinkingCodeCreate>>, UsersAccountLinkingCodeCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  usersAccountLinkingCodeCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersAccountLinkingCodeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersAccountLinkingCodeCreate>>>

    export type UsersAccountLinkingCodeCreateMutationError = void | UsersAccountLinkingCodeCreate403
    export type UsersAccountLinkingCodeCreateMutationVariables = {id: number | 'me'}

    export const useUsersAccountLinkingCodeCreate = <TError = void | UsersAccountLinkingCodeCreate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersAccountLinkingCodeCreate>>, TError,UsersAccountLinkingCodeCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersAccountLinkingCodeCreate>>,
        TError,
        UsersAccountLinkingCodeCreateMutationVariables,
        TContext
      > => {
      return useMutation(getUsersAccountLinkingCodeCreateMutationOptions(options), queryClient);
    }
    export const getUsersActiveLocationsListUrl = (id: number | 'me',
    params?: UsersActiveLocationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/${id}/active-locations/?${stringifiedParams}` : `/api/users/${id}/active-locations/`
}

/**
 * A User represents a person capable of logging into Sidegig.
 *
 * A unique characteristic of this API is that 'me' is a special id value that always refers to the User for the
 * currently authenticated user.
 *
 * For example:
 * <ul>
 * <li><b>GET /users/me</b> returns the currently authenticated users User object</li>
 * <li><b>PUT /users/me</b> updates the currently authenticated users User object</li>
 * </ul>
 *
 * The first time a new user submits any API request a User is automatically created for them by the API. For
 * example, if a new user were to call GET /users/me for their very first API call it would return a new User where
 * the username maps to the authenticated users 'sub' value in their JWT (which ultimately maps to the Auth0 user's
 * username).
 */
export const usersActiveLocationsList = async (id: number | 'me',
    params?: UsersActiveLocationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<LocationDropDownContext[]> => {

  return customFetch<LocationDropDownContext[]>(getUsersActiveLocationsListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersActiveLocationsListQueryKey = (id: number | 'me',
    params?: UsersActiveLocationsListParams,) => {
    return [
    `/api/users/${id}/active-locations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersActiveLocationsListQueryOptions = <TData = Awaited<ReturnType<typeof usersActiveLocationsList>>, TError = void>(id: number | 'me',
    params?: UsersActiveLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersActiveLocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersActiveLocationsListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersActiveLocationsList>>> = ({ signal }) => usersActiveLocationsList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersActiveLocationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersActiveLocationsListQueryResult = NonNullable<Awaited<ReturnType<typeof usersActiveLocationsList>>>
export type UsersActiveLocationsListQueryError = void


export function useUsersActiveLocationsList<TData = Awaited<ReturnType<typeof usersActiveLocationsList>>, TError = void>(
 id: number | 'me',
    params: undefined |  UsersActiveLocationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersActiveLocationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersActiveLocationsList>>,
          TError,
          Awaited<ReturnType<typeof usersActiveLocationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersActiveLocationsList<TData = Awaited<ReturnType<typeof usersActiveLocationsList>>, TError = void>(
 id: number | 'me',
    params?: UsersActiveLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersActiveLocationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersActiveLocationsList>>,
          TError,
          Awaited<ReturnType<typeof usersActiveLocationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersActiveLocationsList<TData = Awaited<ReturnType<typeof usersActiveLocationsList>>, TError = void>(
 id: number | 'me',
    params?: UsersActiveLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersActiveLocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersActiveLocationsList<TData = Awaited<ReturnType<typeof usersActiveLocationsList>>, TError = void>(
 id: number | 'me',
    params?: UsersActiveLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersActiveLocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersActiveLocationsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersApprovedLocationsListUrl = (id: number | 'me',
    params?: UsersApprovedLocationsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/users/${id}/approved-locations/?${stringifiedParams}` : `/api/users/${id}/approved-locations/`
}

/**
 * A User represents a person capable of logging into Sidegig.
 *
 * A unique characteristic of this API is that 'me' is a special id value that always refers to the User for the
 * currently authenticated user.
 *
 * For example:
 * <ul>
 * <li><b>GET /users/me</b> returns the currently authenticated users User object</li>
 * <li><b>PUT /users/me</b> updates the currently authenticated users User object</li>
 * </ul>
 *
 * The first time a new user submits any API request a User is automatically created for them by the API. For
 * example, if a new user were to call GET /users/me for their very first API call it would return a new User where
 * the username maps to the authenticated users 'sub' value in their JWT (which ultimately maps to the Auth0 user's
 * username).
 */
export const usersApprovedLocationsList = async (id: number | 'me',
    params?: UsersApprovedLocationsListParams, options?: Parameters<typeof customFetch>[1]): Promise<LocationDropDownContext[]> => {

  return customFetch<LocationDropDownContext[]>(getUsersApprovedLocationsListUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersApprovedLocationsListQueryKey = (id: number | 'me',
    params?: UsersApprovedLocationsListParams,) => {
    return [
    `/api/users/${id}/approved-locations/`, ...(params ? [params] : [])
    ] as const;
    }


export const getUsersApprovedLocationsListQueryOptions = <TData = Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError = void>(id: number | 'me',
    params?: UsersApprovedLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersApprovedLocationsListQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersApprovedLocationsList>>> = ({ signal }) => usersApprovedLocationsList(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersApprovedLocationsListQueryResult = NonNullable<Awaited<ReturnType<typeof usersApprovedLocationsList>>>
export type UsersApprovedLocationsListQueryError = void


export function useUsersApprovedLocationsList<TData = Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError = void>(
 id: number | 'me',
    params: undefined |  UsersApprovedLocationsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersApprovedLocationsList>>,
          TError,
          Awaited<ReturnType<typeof usersApprovedLocationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersApprovedLocationsList<TData = Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError = void>(
 id: number | 'me',
    params?: UsersApprovedLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersApprovedLocationsList>>,
          TError,
          Awaited<ReturnType<typeof usersApprovedLocationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersApprovedLocationsList<TData = Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError = void>(
 id: number | 'me',
    params?: UsersApprovedLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersApprovedLocationsList<TData = Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError = void>(
 id: number | 'me',
    params?: UsersApprovedLocationsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersApprovedLocationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersApprovedLocationsListQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersCertificationsListUrl = (id: number | 'me',) => {




  return `/api/users/${id}/certifications/`
}

/**
 * Returns a list of certifications assigned to the current or specified user.
 */
export const usersCertificationsList = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<ProCertification[]> => {

  return customFetch<ProCertification[]>(getUsersCertificationsListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersCertificationsListQueryKey = (id: number | 'me',) => {
    return [
    `/api/users/${id}/certifications/`
    ] as const;
    }


export const getUsersCertificationsListQueryOptions = <TData = Awaited<ReturnType<typeof usersCertificationsList>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersCertificationsListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersCertificationsList>>> = ({ signal }) => usersCertificationsList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersCertificationsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersCertificationsListQueryResult = NonNullable<Awaited<ReturnType<typeof usersCertificationsList>>>
export type UsersCertificationsListQueryError = void


export function useUsersCertificationsList<TData = Awaited<ReturnType<typeof usersCertificationsList>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersCertificationsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof usersCertificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersCertificationsList<TData = Awaited<ReturnType<typeof usersCertificationsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersCertificationsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersCertificationsList>>,
          TError,
          Awaited<ReturnType<typeof usersCertificationsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersCertificationsList<TData = Awaited<ReturnType<typeof usersCertificationsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersCertificationsList<TData = Awaited<ReturnType<typeof usersCertificationsList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersCertificationsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersCertificationsListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersDeleteAccountCreateUrl = (id: number | 'me',) => {




  return `/api/users/${id}/delete-account/`
}

/**
 * A User represents a person capable of logging into Sidegig.
 *
 * A unique characteristic of this API is that 'me' is a special id value that always refers to the User for the
 * currently authenticated user.
 *
 * For example:
 * <ul>
 * <li><b>GET /users/me</b> returns the currently authenticated users User object</li>
 * <li><b>PUT /users/me</b> updates the currently authenticated users User object</li>
 * </ul>
 *
 * The first time a new user submits any API request a User is automatically created for them by the API. For
 * example, if a new user were to call GET /users/me for their very first API call it would return a new User where
 * the username maps to the authenticated users 'sub' value in their JWT (which ultimately maps to the Auth0 user's
 * username).
 */
export const usersDeleteAccountCreate = async (id: number | 'me',
    publicGigsterRequest: PublicGigsterRequest, options?: Parameters<typeof customFetch>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<void>(getUsersDeleteAccountCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(publicGigsterRequest)
  }
);}





export const getUsersDeleteAccountCreateMutationKey = () => ['usersDeleteAccountCreate'] as const;

export const getUsersDeleteAccountCreateMutationOptions = <TError = void | UsersDeleteAccountCreate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersDeleteAccountCreate>>, TError,UsersDeleteAccountCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof usersDeleteAccountCreate>>, TError,UsersDeleteAccountCreateMutationVariables, TContext> => {

const mutationKey = getUsersDeleteAccountCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersDeleteAccountCreate>>, UsersDeleteAccountCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  usersDeleteAccountCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersDeleteAccountCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersDeleteAccountCreate>>>
    export type UsersDeleteAccountCreateMutationBody = PublicGigsterRequest
    export type UsersDeleteAccountCreateMutationError = void | UsersDeleteAccountCreate403
    export type UsersDeleteAccountCreateMutationVariables = {id: number | 'me';data: PublicGigsterRequest}

    export const useUsersDeleteAccountCreate = <TError = void | UsersDeleteAccountCreate403,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersDeleteAccountCreate>>, TError,UsersDeleteAccountCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersDeleteAccountCreate>>,
        TError,
        UsersDeleteAccountCreateMutationVariables,
        TContext
      > => {
      return useMutation(getUsersDeleteAccountCreateMutationOptions(options), queryClient);
    }
    export const getUsersLicensesListUrl = (id: number | 'me',) => {




  return `/api/users/${id}/licenses/`
}

/**
 * Returns a list of licenses assigned to the current or specified user.
 */
export const usersLicensesList = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<UserLicense[]> => {

  return customFetch<UserLicense[]>(getUsersLicensesListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersLicensesListQueryKey = (id: number | 'me',) => {
    return [
    `/api/users/${id}/licenses/`
    ] as const;
    }


export const getUsersLicensesListQueryOptions = <TData = Awaited<ReturnType<typeof usersLicensesList>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLicensesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersLicensesListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersLicensesList>>> = ({ signal }) => usersLicensesList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersLicensesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersLicensesListQueryResult = NonNullable<Awaited<ReturnType<typeof usersLicensesList>>>
export type UsersLicensesListQueryError = void


export function useUsersLicensesList<TData = Awaited<ReturnType<typeof usersLicensesList>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLicensesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersLicensesList>>,
          TError,
          Awaited<ReturnType<typeof usersLicensesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersLicensesList<TData = Awaited<ReturnType<typeof usersLicensesList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLicensesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersLicensesList>>,
          TError,
          Awaited<ReturnType<typeof usersLicensesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersLicensesList<TData = Awaited<ReturnType<typeof usersLicensesList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLicensesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersLicensesList<TData = Awaited<ReturnType<typeof usersLicensesList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLicensesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersLicensesListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersLinkableAccountsListUrl = (id: 'me',) => {




  return `/api/users/${id}/linkable-accounts/`
}

/**
 * Returns a list of account linking suggestions for the current user.
 */
export const usersLinkableAccountsList = async (id: 'me', options?: Parameters<typeof customFetch>[1]): Promise<AccountLinking[]> => {

  return customFetch<AccountLinking[]>(getUsersLinkableAccountsListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersLinkableAccountsListQueryKey = (id: 'me',) => {
    return [
    `/api/users/${id}/linkable-accounts/`
    ] as const;
    }


export const getUsersLinkableAccountsListQueryOptions = <TData = Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError = void>(id: 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersLinkableAccountsListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersLinkableAccountsList>>> = ({ signal }) => usersLinkableAccountsList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersLinkableAccountsListQueryResult = NonNullable<Awaited<ReturnType<typeof usersLinkableAccountsList>>>
export type UsersLinkableAccountsListQueryError = void


export function useUsersLinkableAccountsList<TData = Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError = void>(
 id: 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersLinkableAccountsList>>,
          TError,
          Awaited<ReturnType<typeof usersLinkableAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersLinkableAccountsList<TData = Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError = void>(
 id: 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersLinkableAccountsList>>,
          TError,
          Awaited<ReturnType<typeof usersLinkableAccountsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersLinkableAccountsList<TData = Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError = void>(
 id: 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersLinkableAccountsList<TData = Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError = void>(
 id: 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersLinkableAccountsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersLinkableAccountsListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersNotesListUrl = (id: number,) => {




  return `/api/users/${id}/notes/`
}

/**
 * This endpoint returns all user notes associated with a user. Accessible to Gigpro admins and agent admins
 */
export const usersNotesList = async (id: number, options?: Parameters<typeof customFetch>[1]): Promise<UserNote[]> => {

  return customFetch<UserNote[]>(getUsersNotesListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersNotesListQueryKey = (id: number,) => {
    return [
    `/api/users/${id}/notes/`
    ] as const;
    }


export const getUsersNotesListQueryOptions = <TData = Awaited<ReturnType<typeof usersNotesList>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersNotesListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersNotesList>>> = ({ signal }) => usersNotesList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersNotesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersNotesListQueryResult = NonNullable<Awaited<ReturnType<typeof usersNotesList>>>
export type UsersNotesListQueryError = void


export function useUsersNotesList<TData = Awaited<ReturnType<typeof usersNotesList>>, TError = void>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersNotesList>>,
          TError,
          Awaited<ReturnType<typeof usersNotesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersNotesList<TData = Awaited<ReturnType<typeof usersNotesList>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersNotesList>>,
          TError,
          Awaited<ReturnType<typeof usersNotesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersNotesList<TData = Awaited<ReturnType<typeof usersNotesList>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersNotesList<TData = Awaited<ReturnType<typeof usersNotesList>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersNotesListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersNotesCreateUrl = (id: number,) => {




  return `/api/users/${id}/notes/`
}

/**
 * This endpoint creates a new user note. Accessible to Gigpro admins and agent admins
 */
export const usersNotesCreate = async (id: number,
    userNoteRequest: UserNoteRequest, options?: Parameters<typeof customFetch>[1]): Promise<UserNote> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UserNote>(getUsersNotesCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(userNoteRequest)
  }
);}





export const getUsersNotesCreateMutationKey = () => ['usersNotesCreate'] as const;

export const getUsersNotesCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersNotesCreate>>, TError,UsersNotesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof usersNotesCreate>>, TError,UsersNotesCreateMutationVariables, TContext> => {

const mutationKey = getUsersNotesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersNotesCreate>>, UsersNotesCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  usersNotesCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersNotesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersNotesCreate>>>
    export type UsersNotesCreateMutationBody = UserNoteRequest
    export type UsersNotesCreateMutationError = void
    export type UsersNotesCreateMutationVariables = {id: number;data: UserNoteRequest}

    export const useUsersNotesCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersNotesCreate>>, TError,UsersNotesCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersNotesCreate>>,
        TError,
        UsersNotesCreateMutationVariables,
        TContext
      > => {
      return useMutation(getUsersNotesCreateMutationOptions(options), queryClient);
    }
    export const getUsersPerformanceAuditListUrl = (id: number | 'me',) => {




  return `/api/users/${id}/performance-audit/`
}

/**
 * Returns a list of audit records explaining the completion rating for the given Pro.
 *
 * Args:
 *     request ([type]): http request
 *     pk ([type], optional): user id. Defaults to None.
 *
 * Raises:
 *     Http404: Generally used to hide route if requestor is not authorized
 *
 * Returns:
 *     [type]: A list of records explaining why the Pro's completion rating is what it is
 */
export const usersPerformanceAuditList = async (id: number | 'me', options?: Parameters<typeof customFetch>[1]): Promise<CompletionRateAudit[]> => {

  return customFetch<CompletionRateAudit[]>(getUsersPerformanceAuditListUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersPerformanceAuditListQueryKey = (id: number | 'me',) => {
    return [
    `/api/users/${id}/performance-audit/`
    ] as const;
    }


export const getUsersPerformanceAuditListQueryOptions = <TData = Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError = void>(id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersPerformanceAuditListQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersPerformanceAuditList>>> = ({ signal }) => usersPerformanceAuditList(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersPerformanceAuditListQueryResult = NonNullable<Awaited<ReturnType<typeof usersPerformanceAuditList>>>
export type UsersPerformanceAuditListQueryError = void


export function useUsersPerformanceAuditList<TData = Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError = void>(
 id: number | 'me', options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersPerformanceAuditList>>,
          TError,
          Awaited<ReturnType<typeof usersPerformanceAuditList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersPerformanceAuditList<TData = Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersPerformanceAuditList>>,
          TError,
          Awaited<ReturnType<typeof usersPerformanceAuditList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersPerformanceAuditList<TData = Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersPerformanceAuditList<TData = Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError = void>(
 id: number | 'me', options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersPerformanceAuditList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersPerformanceAuditListQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUsersLogoutAllDevicesCreateUrl = () => {




  return `/api/users/logout-all-devices/`
}

/**
 * Revoke every active session of the authenticated user, including the current one.
 */
export const usersLogoutAllDevicesCreate = async ( options?: Parameters<typeof customFetch>[1]): Promise<UsersLogoutAllDevicesCreate200> => {

  return customFetch<UsersLogoutAllDevicesCreate200>(getUsersLogoutAllDevicesCreateUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getUsersLogoutAllDevicesCreateMutationKey = () => ['usersLogoutAllDevicesCreate'] as const;

export const getUsersLogoutAllDevicesCreateMutationOptions = <TError = void | NotFoundError | ServiceUnavailableError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersLogoutAllDevicesCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof usersLogoutAllDevicesCreate>>, TError,void, TContext> => {

const mutationKey = getUsersLogoutAllDevicesCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersLogoutAllDevicesCreate>>, void> = () => {


          return  usersLogoutAllDevicesCreate(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UsersLogoutAllDevicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof usersLogoutAllDevicesCreate>>>

    export type UsersLogoutAllDevicesCreateMutationError = void | NotFoundError | ServiceUnavailableError


    export const useUsersLogoutAllDevicesCreate = <TError = void | NotFoundError | ServiceUnavailableError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersLogoutAllDevicesCreate>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersLogoutAllDevicesCreate>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getUsersLogoutAllDevicesCreateMutationOptions(options), queryClient);
    }
    export const getUsersNotesRetrieveUrl = (uuid: string,) => {




  return `/api/users/notes/${uuid}/`
}

/**
 * This endpoint returns a specified user note. Accessible to Gigpro admins and agent admins
 */
export const usersNotesRetrieve = async (uuid: string, options?: Parameters<typeof customFetch>[1]): Promise<UserNote> => {

  return customFetch<UserNote>(getUsersNotesRetrieveUrl(uuid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getUsersNotesRetrieveQueryKey = (uuid: string,) => {
    return [
    `/api/users/notes/${uuid}/`
    ] as const;
    }


export const getUsersNotesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof usersNotesRetrieve>>, TError = void>(uuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUsersNotesRetrieveQueryKey(uuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof usersNotesRetrieve>>> = ({ signal }) => usersNotesRetrieve(uuid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uuid !== null && uuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof usersNotesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UsersNotesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof usersNotesRetrieve>>>
export type UsersNotesRetrieveQueryError = void


export function useUsersNotesRetrieve<TData = Awaited<ReturnType<typeof usersNotesRetrieve>>, TError = void>(
 uuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersNotesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersNotesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersNotesRetrieve<TData = Awaited<ReturnType<typeof usersNotesRetrieve>>, TError = void>(
 uuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof usersNotesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof usersNotesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUsersNotesRetrieve<TData = Awaited<ReturnType<typeof usersNotesRetrieve>>, TError = void>(
 uuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUsersNotesRetrieve<TData = Awaited<ReturnType<typeof usersNotesRetrieve>>, TError = void>(
 uuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof usersNotesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUsersNotesRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






